import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["value"];
import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
import I18n from 'I18n';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedSize(t0) {
  const $ = _c(2);
  const {
      value
    } = t0,
    options = _objectWithoutPropertiesLoose(t0, _excluded);
  useContext(I18nHMRContext);
  const t1 = I18n.formatSize(value, options);
  let t2;
  if ($[0] !== t1) {
    t2 = /*#__PURE__*/_jsx("span", {
      children: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}
FormattedSize.displayName = 'FormattedSize';
export default FormattedSize;